import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default class ContextMenu extends Component {
    constructor(props) {
        super(props);

        this.wrapperRef = React.createRef();
        // this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside(event) {
        if (this.props.show && !this.wrapperRef.current.contains(event.target)) {
            // alert('You clicked outside of me!');
            // this.props.show=false;
            this.props.hideMenu(this);
            // alert("dsdsdd");
        }
    }

    menuClicked(title,target){
        // alert(title);
        if (this.props.isChart){
            this.props.menuClicked(target);
        }else{
            this.props.menuClicked(title);
        }
        // this.props.menuClicked(title);
        this.props.hideMenu(this);
    }

    render() {
        // if (!this.props.show){
        //     return null;
        // }

        return (
            <div className="brokerContext" style={{top:this.props.topp,left:this.props.leftt}} ref={this.wrapperRef}>
                {this.props.dataa.map((item, i)=>(
                    <div key={i} className="menuItem" index={i} onClick={this.menuClicked.bind(this,item.title,item.target)}>
                        {item.icon && <FontAwesomeIcon style={{marginLeft:'10px'}} icon={item.icon} />}
                        {item.title}
                    </div>
                ))}
                {/* <div style={{backgroundColor:'red',width:'100px',hight:'100px',position:'absolute' }}></div> */}
            </div>
        )
    }
}
//onClick={this.basketItemClicked.bind(this,i,item.id)}
